import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["loading", "recordAttributeIdentifier", "children"];
import React, { useRef } from 'react';
import { useHorizontalScrollAtEnd } from '../../hooks/useHorizontalScrollAtEnd';
import { StickTo } from '../../Table.decl';
import { TableRootContext } from './context';
import { TableWrapper } from './styled';
export var TableRoot = function TableRoot(_ref) {
  var _scrollAtEnd;

  var loading = _ref.loading,
      _ref$recordAttributeI = _ref.recordAttributeIdentifier,
      recordAttributeIdentifier = _ref$recordAttributeI === void 0 ? 'id' : _ref$recordAttributeI,
      children = _ref.children,
      styleProps = _objectWithoutPropertiesLoose(_ref, _excluded);

  var tableWrapperRef = useRef();
  var isScrollAtLeftEnd = useHorizontalScrollAtEnd(tableWrapperRef == null ? void 0 : tableWrapperRef.current, StickTo.Left);
  var isScrollAtRightEnd = useHorizontalScrollAtEnd(tableWrapperRef == null ? void 0 : tableWrapperRef.current, StickTo.Right);
  return /*#__PURE__*/React.createElement(TableWrapper, _extends({
    ref: tableWrapperRef
  }, styleProps), /*#__PURE__*/React.createElement(TableRootContext.Provider, {
    value: {
      horizontallyScrollableContainerRef: tableWrapperRef,
      loading: loading,
      recordAttributeIdentifier: recordAttributeIdentifier,
      scrollAtEnd: (_scrollAtEnd = {}, _scrollAtEnd[StickTo.Left] = !!isScrollAtLeftEnd, _scrollAtEnd[StickTo.Right] = !!isScrollAtRightEnd, _scrollAtEnd)
    }
  }, children));
};